import { inject, ref } from 'vue';
import {
  fetchEmploymentReferenceOptions,
  invalidateEmploymentReferenceOptions,
} from '@/api/employmentReferenceApi';
import { resetEmploymentReferenceCatalogSnapshot } from '@/composables/useEmploymentReferenceCatalog';

/**
 * Settings employment reference list pattern (types + companies).
 * See docs/SETTINGS_EMPLOYMENT_REFERENCE.md
 */
export function useSettingsEmploymentReferenceList() {
  const showInactive = ref(false);
  const refreshWorkspaceStats = inject('refreshWorkspaceStats', null);

  const fetchOptions = () =>
    fetchEmploymentReferenceOptions({
      force: true,
      includeInactive: showInactive.value,
    });

  const afterMutation = async (reloadFn) => {
    invalidateEmploymentReferenceOptions();
    resetEmploymentReferenceCatalogSnapshot();
    if (typeof reloadFn === 'function') {
      await reloadFn();
    }
    refreshWorkspaceStats?.();
  };

  return {
    showInactive,
    fetchOptions,
    afterMutation,
  };
}
